import { replaceUserEndpoint } from './userEndpoint';

export function todayIsoDate() {
	const d = new Date();
	const pad = (n) => String(n).padStart(2, '0');
	return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function formatBloodPressureChartLabel(entry) {
	if (entry.date) {
		const parsed = new Date(`${entry.date}T12:00:00`);
		if (!Number.isNaN(parsed.getTime())) {
			return parsed.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
		}
	}
	return entry.month || '';
}

export function latestBloodPressureString(trend) {
	if (!trend?.length) return null;
	const last = trend[trend.length - 1];
	if (Number.isFinite(last.systolic) && Number.isFinite(last.diastolic)) {
		return `${last.systolic}/${last.diastolic}`;
	}
	return null;
}

export function replaceFitnessProfileEndpoint(template, { userId, fitnessProfileId }) {
	return replaceUserEndpoint(template, { userId, fitnessProfileId });
}

export function replaceFitnessProfileReadingEndpoint(template, { userId, fitnessProfileId, readingId }) {
	return replaceFitnessProfileEndpoint(template, { userId, fitnessProfileId }).replace(
		/\/(id|:id)$/,
		`/${readingId}`
	);
}

export function sortReadingsNewestFirst(readings = []) {
	return [...readings].sort((a, b) => {
		const aTime = new Date(a.recorded_at).getTime();
		const bTime = new Date(b.recorded_at).getTime();
		return bTime - aTime;
	});
}

export function formatRecordedAtLabel(reading) {
	const date =
		reading.recorded_on ||
		(typeof reading.recorded_at === 'string' ? reading.recorded_at.slice(0, 10) : '');
	return formatBloodPressureChartLabel({ date });
}

export function apiBloodPressuresToTrend(readings = []) {
	return readings.map((reading) => {
		const date =
			reading.recorded_on ||
			(typeof reading.recorded_at === 'string' ? reading.recorded_at.slice(0, 10) : '');
		return {
			date,
			systolic: reading.systolic,
			diastolic: reading.diastolic,
			month: formatBloodPressureChartLabel({ date })
		};
	});
}

export function bloodPressureFormFromReading(reading) {
	const date =
		reading?.recorded_on ||
		(typeof reading?.recorded_at === 'string' ? reading.recorded_at.slice(0, 10) : '') ||
		todayIsoDate();
	return {
		date,
		systolic: reading?.systolic == null ? '' : String(reading.systolic),
		diastolic: reading?.diastolic == null ? '' : String(reading.diastolic),
		editingId: reading?.id ?? null
	};
}

export function validateBloodPressureInput(systolicRaw, diastolicRaw) {
	const systolic = Number.parseInt(String(systolicRaw).trim(), 10);
	const diastolic = Number.parseInt(String(diastolicRaw).trim(), 10);
	if (!Number.isFinite(systolic) || !Number.isFinite(diastolic)) {
		return { valid: false, error: 'Enter both systolic and diastolic values.' };
	}
	if (systolic < 70 || systolic > 250) {
		return { valid: false, error: 'Systolic should be between 70 and 250.' };
	}
	if (diastolic < 40 || diastolic > 150) {
		return { valid: false, error: 'Diastolic should be between 40 and 150.' };
	}
	if (diastolic >= systolic) {
		return { valid: false, error: 'Diastolic must be lower than systolic.' };
	}
	return { valid: true, systolic, diastolic };
}
